import { avisosDaCena, type AvisoTabletop, type CenaTabletop, type ConfiguracaoAvisos } from '../../dominio/tabletop'

const TITULOS: Readonly<Record<AvisoTabletop['tipo'], string>> = {
  'ponta-solta': 'Ponta solta',
  'corda-sem-ancoragem': 'Corda sem ancoragem',
  'angulo-ancoragem': 'Ângulo da ancoragem',
  'angulo-envolvimento': 'Ângulo da fita no tronco',
  'mosquetao-carga-lateral': 'Mosquetão puxado de lado',
  'icamento-sem-seguranca': 'Içamento sem segurança',
  'escada-sem-estabilizacao': 'Escada sem estabilização',
  'queda-bate-no-chao': 'Queda bate antes de parar',
  'talabarte-curto': 'Talabarte curto demais',
  'fator-de-queda-alto': 'Fator de queda alto',
  'talabarte-sem-absorvedor': 'Talabarte sem absorvedor',
  'balanco-bate-na-estrutura': 'Balanço bate na estrutura',
  'corda-sem-funcao': 'Corda sem função',
  'corda-em-aresta': 'Corda em quina viva',
  'ruptura-de-talabarte': 'Ruptura de talabarte',
  'estaca-puxada-no-topo': 'Estaca puxada no topo',
}

export interface PropsPainelAvisos {
  cena: CenaTabletop
  configuracao?: ConfiguracaoAvisos
  /** Leva o instrutor até o que o aviso aponta: a corda, a ancoragem ou o objeto. */
  aoIrPara: (aviso: AvisoTabletop) => void
}

/**
 * Os avisos didáticos da montagem. Nada é bloqueado: a lista só mostra o que um
 * instrutor olharia, e tocar num aviso seleciona o que ele aponta.
 */
export function PainelAvisos({ cena, configuracao, aoIrPara }: PropsPainelAvisos) {
  const avisos = avisosDaCena(cena, configuracao)
  return (
    <div className="grupo-controle painel-avisos">
      <span className="titulo-controle">Avisos da montagem</span>
      {avisos.length === 0 ? (
        <p className="dica-tabletop" role="status">
          Nenhum aviso. A montagem não tem ponta solta, corda sem ancoragem, ângulo acima do limite, içamento sem segurança nem escada sem estabilização.
        </p>
      ) : (
        <>
          <p className="dica">São avisos didáticos: o app não bloqueia nada. Toque num aviso para ver o que ele aponta.</p>
          <ul className="lista-avisos">
            {avisos.map((aviso) => (
              <li key={aviso.id}>
                <button type="button" className="btn-aviso" onClick={() => aoIrPara(aviso)}>
                  <strong>{TITULOS[aviso.tipo]}</strong>
                  <span>{aviso.mensagem}</span>
                </button>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  )
}
